import React, { FC, useState } from "react";
import { Col, Input, Row } from "antd";

import { IModal } from "@types";
import Modal from "@components/Modal";
import {
  ErrorServices,
  useCreateCompanySubJobFunctionMutation,
} from "@services";
import { useTypedSelector } from "@/hooks";
import Button from "@/components/Button";

export interface IAddJobSubFunction extends IModal {
  company_job_function_id: string | number;
}

const { TextArea } = Input;

const AddCompanyJobSubFunction: FC<IAddJobSubFunction> = ({
  isVisible,
  setIsVisible,
  company_job_function_id,
  companyId,
}) => {
  const { user } = useTypedSelector(state => state.auth);

  const [jobSubFunction, setJobSubFunction] = useState("");
  const [description, setDescription] = useState("");

  const [createCompanySubJobFunction, { isLoading }] =
    useCreateCompanySubJobFunctionMutation();

  const onSubmit = async () => {
    try {
      await createCompanySubJobFunction({
        company_id: companyId,
        name: jobSubFunction,
        description,
        company_job_function_id,
      }).unwrap();

      closeModal();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const closeModal = () => {
    setIsVisible(false);
    setJobSubFunction("");
    setDescription("");
  };

  return (
    <Modal
      width={544}
      onClose={closeModal}
      footer={[
        <Button
          key="1"
          variant="buttonCore"
          disabled={!jobSubFunction.trim() || isLoading}
          onClick={onSubmit}
          isLoading={isLoading}
          className="w-56"
        >
          Add
        </Button>,

        <Button
          key="2"
          variant="buttonBlue"
          onClick={closeModal}
          className="w-28"
        >
          Cancel
        </Button>,
      ]}
      title="Add a Job-Sub Function"
      isVisible={isVisible}
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col span={24}>
            <label>Job-Sub Function</label>
            <Input
              value={jobSubFunction}
              onChange={e => setJobSubFunction(e.target.value)}
              size="large"
              placeholder="Name of the job-sub function here..."
            />
          </Col>
        </Row>

        <Row
          justify="space-between"
          className="modal__row"
          style={{ marginTop: 16 }}
        >
          <Col span={24}>
            <label>Description</label>
            <TextArea
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={4}
              placeholder="Description here..."
            />
          </Col>
        </Row>
      </>
    </Modal>
  );
};

export default AddCompanyJobSubFunction;
